const zillowListingMatch = url => {
  const result = url.match(/^https:\/\/www\.zillow\.com\//);
  return result && result.length === 1;
};

const zillowHomeDetailsUrl = url => url.replace(/\/homes\//g, "/homedetails/");

export { zillowListingMatch, zillowHomeDetailsUrl };
